import React from 'react'
import { Table } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import { maskIdCard } from '../../utils/dataUtil'

export default function SummaryReporteFillingTable({ data, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  return (
    <>
      <Table wordWrap autoHeight data={data || []} style={{ marginTop: 10 }} headerHeight={100}>
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (rowData.isTotal) {
                return
              }
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={180} resizable colSpan={3}>
          <HeaderCell>เลขประจำตัวผู้เสียภาษีอากร</HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.isTotal) {
                return (
                  <p style={{ textAlign: 'center' }}>
                    <b>{maskIdCard(rowData.taxId)}</b>
                  </p>
                )
              }
              return maskIdCard(rowData.taxId)
            }}
          </Cell>
        </Column>

        <Column width={180} resizable>
          <HeaderCell>ชื่อผู้มีเงินได้</HeaderCell>
          <Cell dataKey="fullName" />
        </Column>

        <Column width={300} resizable>
          <HeaderCell>ที่อยู่ของผู้มีเงินได้</HeaderCell>
          <Cell dataKey="address" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>จำนวนเงินได้ที่จ่ายทั้งปี</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.taxBaseAmount1 || 0)}</b>
              }
              return budgetFormat(rowData.taxBaseAmount1 || 0)
            }}
          </Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หักและนำส่งทั้งปี</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.taxAmount1 || 0)}</b>
              }
              return budgetFormat(rowData.taxAmount1 || 0)
            }}
          </Cell>
        </Column>

        <Column width={50} align={'center'} resizable>
          <HeaderCell>เงื่อนไข</HeaderCell>
          <Cell dataKey="taxCondition1" />
        </Column>
      </Table>
    </>
  )
}
